const handleProductModelChange = () => {
	const $trigger = $('.product-model__arrow--left, .product-model__arrow--right');

	$trigger.on('click', function(event) {
		const $this = $(this);
		const $currentMenuItem = $this.closest('.tabs').find('.tabs__nav .is-current');

		if ($(event.currentTarget).hasClass('product-model__arrow--left')) {
			$currentMenuItem.prev().find('a').trigger('click');
		} else if ($(event.currentTarget).hasClass('product-model__arrow--right')) {
			$currentMenuItem.next().find('a').trigger('click');
		}

		event.preventDefault();
	});
}

handleProductModelChange();
